/* @flow */

import React from 'react';
import { Message, Embed } from 'semantic-ui-react';
import { getVideoPlaceholder } from 'utils/resources';

type Props = {
  block: EditorialYoutubeBlock,
};

const View = ({ block }: Props) => {
  if (block.youtubeId && block.youtubeId.length) {
    return (
      <Embed
        id={block.youtubeId}
        placeholder={block.thumbnail || getVideoPlaceholder}
        source="youtube"
      />
    );
  }

  return <Message icon="info" header="Aucune vidéo spécifiée" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/youtube/View.js